import React from "react";
import "./page.css";
import "../components/disabled.css";
import { ReactComponent as Lock } from "../asset/lock.svg";
import {
  Slider,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Divider,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import { connect } from "react-redux";

import { calculate, forList2 } from "../functions/CalculateTaishoku.js";
import handleUpdate from "../functions/handleUpdate";
import Tutrial from "../components/Tutrial";
import TutrialImage1 from "../asset/tutrial/ser2/tutrial1.gif";
import TutrialImage2 from "../asset/tutrial/ser2/tutrial2.jpg";

import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import StackedColumn2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

import { LogoCover } from "../components/LogoCover";

import firebase from "../firebase";

ReactFC.fcRoot(FusionCharts, StackedColumn2D, FusionTheme);

const dataSource = {
  chart: {
    caption: "退職所得控除と所得税の割合",
    numberSuffix: "万円",
    theme: "fusion",
    yAxisValuesPadding: 0,
    formatNumberScale: 0,
    usePlotGradientColor: 0,
    yAxisMaxValue: 0,
    valueFontColor: "#ffffff",
    plotBorderColor: "#bababa",
    plotBorderThickness: 1,
    reverseLegend: 1,
    bgColor: "#ffffff",
    showXAxisLine: true,
    showYAxisLine: true,
    showYAxisValues: true,
  },
  categories: [
    {
      category: [
        {
          label: "",
        },
      ],
    },
  ],
  dataset: [
    {
      seriesname: "所得税額",
      color: "#D63135",
      data: [
        {
          value: "",
        },
      ],
    },
    {
      seriesname: "控除後1/2-税額",
      color: "#005a98",
      data: [
        {
          value: "",
        },
      ],
    },
    {
      seriesname: "控除後の1/2",
      color: "#004573",
      data: [
        {
          value: "",
        },
      ],
    },
    {
      seriesname: "退職所得控除",
      color: "#002E4D",
      data: [
        {
          value: "",
        },
      ],
    },
  ],
};

const chartConfigs = {
  type: "stackedcolumn2d", // The chart type
  width: "100%", // Width of the chart
  height: "400", // Height of the chart
  dataFormat: "json", // Data type
  dataSource: dataSource,
};

let list = forList2(10000, 10);
let result = calculate(10000, 10);

class SeverancePay2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: dataSource,
      getsugaku: 50,
      shuunin: 25,
      yuutai: 70,
      upToFiveYear: false,
      kouseki: 3,
      calculationCount: 0,
      tutrial: false
    };
  }

  async componentDidMount() {
    // const analytics = firebase.analytics();
    // analytics.logEvent('screen_view', { screen_name: '退職金支給可能目安' });
    //console.log('send log');
    if (this.props.isPaid === false) {
      this.setState({ kouseki: 2 });
    }
    let duration = Number(this.state.yuutai) - Number(this.state.shuunin);
    let meyasu = Number(this.state.getsugaku) * this.state.kouseki * duration;
    result = calculate(meyasu, duration);
    list = forList2(meyasu, duration);
    let dataSource = this.state.dataSource;
    dataSource.dataset[3].data[0].value = Number(result.taishokuKoujyo);
    dataSource.dataset[2].data[0].value = Number(result.taishokuShotoku);
    dataSource.dataset[1].data[0].value = Math.round(
      Number(
        result.taishokuShotoku -
        (result.shotokuZei + result.shimin + result.kenmin)
      )
    );
    dataSource.dataset[0].data[0].value = Math.round(
      Number(result.shotokuZei + result.shimin + result.kenmin)
    );
    dataSource.chart.yAxisMaxValue =
      Number(result.taishokuKoujyo) +
      Number(result.taishokuShotoku) +
      Math.round(
        Number(
          result.taishokuShotoku -
          (result.shotokuZei + result.shimin + result.kenmin)
        )
      ) +
      Math.round(Number(result.shotokuZei + result.shimin + result.kenmin));
    this.setState({ dataSource: dataSource });
    const ended = localStorage.getItem("tutrial6");
    if (ended) {
      this.setState({ tutrial: false });
    } else {
      this.setState({ tutrial: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //console.log('start update checking top');
    handleUpdate();
    const analytics = firebase.analytics();
    // console.log('true?: ', Number(this.state.shuunin) > Number(this.state.yuutai) && this.state.yuutai.length === 2 && this.state.yuutai.length === 2);
    let duration = Number(this.state.yuutai) - Number(this.state.shuunin);
    // console.log('duration: ', duration);
    if (duration < 0) {
      duration = 0;
    }
    if (
      this.state.shuunin !== prevState.shuunin ||
      this.state.yuutai !== prevState.yuutai
    ) {
      if (duration <= 5) {
        this.setState({ upToFiveYear: true });
        // console.log('duration <= 5', duration <= 5);
      } else if (duration > 5) {
        // console.log('duration > 5: ', duration > 5);
        this.setState({ upToFiveYear: false });
      }
    }

    const meyasu =
      Number(this.state.getsugaku) * Number(this.state.kouseki) * duration;
    result = calculate(meyasu, duration);
    list = forList2(meyasu, duration);
    if (
      this.state.getsugaku !== prevState.getsugaku ||
      this.state.shuunin !== prevState.shuunin ||
      this.state.yuutai !== prevState.yuutai ||
      this.state.kouseki !== prevState.kouseki
    ) {
      let dataSource = this.state.dataSource;
      dataSource.dataset[3].data[0].value = Number(result.taishokuKoujyo);
      dataSource.dataset[2].data[0].value = Number(result.taishokuShotoku);
      dataSource.dataset[1].data[0].value = Math.round(
        Number(
          result.taishokuShotoku -
          (result.shotokuZei + result.shimin + result.kenmin)
        )
      );
      dataSource.dataset[0].data[0].value = Math.round(
        Number(result.shotokuZei + result.shimin + result.kenmin)
      );
      dataSource.chart.yAxisMaxValue =
        Number(result.taishokuKoujyo) +
        Number(result.taishokuShotoku) +
        Math.round(
          Number(
            result.taishokuShotoku -
            (result.shotokuZei + result.shimin + result.kenmin)
          )
        ) +
        Math.round(Number(result.shotokuZei + result.shimin + result.kenmin));
      this.setState({ dataSource: dataSource });

      analytics.logEvent("calculation");
      this.setState({ calculationCount: this.state.calculationCount + 1 });

      if (this.state.calculationCount % 10 === 0) {
        //console.log("calculate 10 times :", this.state.calculationCount);
        analytics.logEvent("calculate10times");
      }
    }
  }

  handleChange = (event) => {
    this.setState({ kouseki: event.target.value });
  };


  closeTutrial = () => {
    localStorage.setItem("tutrial6", "ended");
    this.setState({ tutrial: false })
  };


  render() {
    const upToFiveYear = this.state.upToFiveYear;
    // console.log('upToFiveYear: ',upToFiveYear);
    return (
      <>
        {this.state.tutrial ? <Tutrial closeTutrial={this.closeTutrial} image1={TutrialImage1} image2={TutrialImage2} /> :
          <div className="container">
            <section className="userArea">
              <div className="slider-box">
                <div className="slider-title" style={{ margin: 0 }}>
                  <span style={{ color: "#006699", fontWeight: "bold" }}>
                    役員就任年齢
                  </span>
                  : {this.state.shuunin} 歳
                </div>
                <Slider
                  value={this.state.shuunin}
                  max={60}
                  min={20}
                  step={1}
                  onChange={(event, newValue) =>
                    this.setState({ shuunin: newValue })
                  }
                  color={"secondary"}
                />
                <div className="slider-title">
                  <span style={{ color: "#006699", fontWeight: "bold" }}>
                    勇退予定年齢
                  </span>
                  : {this.state.yuutai} 歳
                </div>
                <Slider
                  value={this.state.yuutai}
                  max={90}
                  min={60}
                  step={1}
                  onChange={(event, newValue) =>
                    this.setState({ yuutai: newValue })
                  }
                  color={"secondary"}
                />
                <div className="slider-title">
                  <span style={{ color: "#006699", fontWeight: "bold" }}>
                    報酬月額
                  </span>
                  : {this.state.getsugaku} 万円
                </div>
                <Slider
                  value={this.state.getsugaku}
                  max={1000}
                  min={50}
                  step={50}
                  onChange={(event, newValue) =>
                    this.setState({ getsugaku: newValue })
                  }
                  color={"secondary"}
                />
                {this.props.isPaid && !this.props.needEmailVerify ? (
                  <div className="kousekibairitsu">
                    <InputLabel>功績倍率</InputLabel>
                    <Select
                      value={this.state.kouseki}
                      onChange={this.handleChange}
                      autoWidth={true}
                      color={"secondary"}
                    >
                      <MenuItem value={2}>2倍</MenuItem>
                      <MenuItem value={2.5}>2.5倍</MenuItem>
                      <MenuItem value={3}>3倍</MenuItem>
                    </Select>
                  </div>
                ) : (
                  <div className="kousekibairitsu-disabled">
                    <div className="disabled-filter"></div>
                    <Lock
                      className="lock-icon"
                      onClick={() =>
                        alert("アップグレードすると功績倍率を変更できます")
                      }
                    />

                    <InputLabel>功績倍率</InputLabel>
                    <Select
                      value={this.state.kouseki}
                      onChange={this.handleChange}
                      autoWidth={true}
                      color={"secondary"}
                      disabled
                    >
                      <MenuItem value={2}>2倍</MenuItem>
                      <MenuItem value={2.5}>2.5倍</MenuItem>
                      <MenuItem value={3}>3倍</MenuItem>
                    </Select>
                  </div>
                )}
              </div>
            </section>
            <Divider style={{ backgroundColor: "#cfd8dc" }} />
            <section className="resultArea">
              <div className="listContainer" style={{ padding: 0 }}>
                {upToFiveYear ? (
                  <TableContainer>
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell align="left" className="error-message">
                            在任年数5年以下は対応していません
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <div>
                    {list.map((l, i) => (
                      <TableContainer key={i}>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell component="th" scope="row">
                                {l.name}
                              </TableCell>
                              <TableCell align="right">{l.value}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ))}
                  </div>
                )}
              </div>
              <div className="chartContainer">
                <ReactFC {...chartConfigs} />
                <LogoCover></LogoCover>
              </div>
            </section>
          </div>}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isPaid: state.user.isPaid,
  needEmailVerify: state.user.needEmailVerify
});

export default connect(mapStateToProps)(SeverancePay2);
